import { lazy, Suspense } from 'react'
import DashboardLayout from '../layouts/Dashboard'
import AuthGuard from '../components/guards/AuthGuard'
import { ConfluencePages, UserRole } from '../enums'
import { UserManualProvider } from '../contexts/userManual'
import Redirect from '../pages/Redirect'
import LoadingState from '../components/LoadingState'

const Devices = lazy(() => import('../pages/pages/Devices'))
const DeviceManagement = lazy(() => import('../pages/pages/DeviceManagement'))
const Device = lazy(() => import('../pages/pages/Device'))
const DeviceAlerts = lazy(() => import('../pages/pages/DeviceAlerts'))
const DeviceEdit = lazy(() => import('../pages/pages/EditDevice'))
// const DeviceLocation = lazy(() => import('../pages/pages/DeviceLocation'))
const DeviceSensorErrors = lazy(() => import('../pages/pages/DeviceSensorErrors'))
const DeviceStats = lazy(() => import('../pages/pages/DeviceStats'))
const DeviceTroubleshoot = lazy(() => import('../pages/pages/DeviceTroubleshoot'))
const DeviceReplace = lazy(() => import('../pages/pages/DeviceReplace'))
const DeviceMessages = lazy(() => import('../pages/pages/DeviceMessages'))
const DeviceMidReport = lazy(() => import('../pages/pages/DeviceMidReport'))
const PowerSupplyDocuments = lazy(() => import('../pages/pages/PowerSupplyDocuments'))
const Valve = lazy(() => import('../pages/Valve'))
const ValveStats = lazy(() => import('../pages/ValveStats'))

export default [
  {
    path: '/devices',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <UserManualProvider pageId={ConfluencePages.DEVICES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <Devices />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/devices/management',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <UserManualProvider pageId={ConfluencePages.DEVICES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <DeviceManagement />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/devices/replace',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN, UserRole.ADMIN, UserRole.USER, UserRole.INSTALLER]}>
        <UserManualProvider pageId={ConfluencePages.DEVICES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <DeviceReplace />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/devices/:id',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER,
          UserRole.GUEST
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.DEVICES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <Device />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/devices/:id/valve',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER,
          UserRole.GUEST
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.DEVICES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <Valve />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/devices/:id/valve/stats',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER,
          UserRole.GUEST
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.DEVICES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <ValveStats />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/devices/:id/valve/messages',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER,
          UserRole.GUEST
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.DEVICES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <ValveStats />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/devices/:id/edit',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.DEVICES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <DeviceEdit />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/devices/:id/powerSupplyDocuments',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.DEVICES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <PowerSupplyDocuments />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  // {
  //   path: '/devices/:id/location',
  //   element: (
  //     <AuthGuard
  //       roles={[
  //         UserRole.SUPERADMIN,
  //         UserRole.ADMIN,
  //         UserRole.USER,
  //         UserRole.MANUFACTURER,
  //         UserRole.INSTALLER,
  //         UserRole.GUEST
  //       ]}
  //     >
  //       <UserManualProvider pageId={ConfluencePages.DEVICES}>
  //         <DashboardLayout>
  //           <Suspense fallback={<LoadingState align="center" />}>
  //             <DeviceLocation />
  //           </Suspense>
  //         </DashboardLayout>
  //       </UserManualProvider>
  //     </AuthGuard>
  //   )
  // },
  {
    path: '/devices/:id/stats',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER,
          UserRole.GUEST
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.DEVICES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <DeviceStats />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/devices/:name/alerts',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.INSTALLER,
          UserRole.USER,
          UserRole.MANUFACTURER
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.DEVICES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <DeviceAlerts />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/devices/:name/messages',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER,
          UserRole.GUEST
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.DEVICES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <DeviceMessages />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/devices/:id/troubleshoot',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <UserManualProvider pageId={ConfluencePages.DEVICES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <DeviceTroubleshoot />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/devices/:name/sensor-errors',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <UserManualProvider pageId={ConfluencePages.DEVICES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <DeviceSensorErrors />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/devices/:name/mid-report',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <UserManualProvider pageId={ConfluencePages.DEVICES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <DeviceMidReport />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/devices/:name/alert-management',
    element: <Redirect to="/devices/:name/alerts" />
  },
  {
    path: '/devices/:id/sensor-aggregates',
    element: <Redirect to="/devices/:id/stats" />
  },
  {
    path: '/devices/:id/edit/location',
    element: <Redirect to="/devices/:id/location" />
  }
]
